<h2 mat-dialog-title>Horarios de {{ nombreUsuario }}</h2>
<mat-dialog-content>
  <mat-form-field appearance="outline" >
    <mat-label>Filtro</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Filtro" #input />
  </mat-form-field>
  <mat-form-field
  style="padding-left: 10px"
>
  <mat-label>Disciplina</mat-label>
  <mat-select
    [(ngModel)]="disciplinaSelect"
    (selectionChange)="cambioDiscipinaBuscar()"
  >
    <mat-option disabled> Seleccione una disciplina</mat-option>
    <mat-option
      *ngFor="let disciplinaTmp of lstDisciplinas"
      [value]="disciplinaTmp.id"
    >
      {{ disciplinaTmp.nombre }}
    </mat-option>
  </mat-select>
</mat-form-field>

  <div class="mat-elevation-z1 contenedorTabla" *ngIf="!isLoadingResults">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="nombre">
        <th mat-header-cell *matHeaderCellDef>Nombre</th>
        <td mat-cell *matCellDef="let element">{{ element.nombre }}</td>
      </ng-container>

      <ng-container matColumnDef="disciplina">
        <th mat-header-cell *matHeaderCellDef>Disciplina</th>
        <td mat-cell *matCellDef="let element">{{ element.disciplina }}</td>
      </ng-container>

      <ng-container matColumnDef="dias">
        <th mat-header-cell *matHeaderCellDef>Días</th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="element.lunes">Lun </span>
          <span *ngIf="element.martes">Mar </span>
          <span *ngIf="element.miercoles">Mier </span>
          <span *ngIf="element.jueves">Jue </span>
          <span *ngIf="element.viernes">Vier </span>
          <span *ngIf="element.sabado">Sab </span>
          <span *ngIf="element.domingo">Dom </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="horario">
        <th mat-header-cell *matHeaderCellDef>Horario</th>
        <td mat-cell *matCellDef="let element">
          Desde {{ element.horaInicio }} hasta {{ element.horaFin }}
        </td>
      </ng-container>

<!--       <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef>Asignado</th>
        <td mat-cell *matCellDef="let element">{{ element.asignado }}</td>
      </ng-container> -->

      <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef>Asignado</th>
        <td mat-cell *matCellDef="let element" style="text-align: center;">
          <mat-slide-toggle [checked]="element.asignado" (change)="onToggle($event, element)"></mat-slide-toggle>
        </td>
      </ng-container>



      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      #paginator
      [length]="length"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [pageSizeOptions]="[200,10, 25, 100]"
      (page)="getServerData($event)"
    ></mat-paginator>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <!--  <button type="submit" mat-button mat-flat-button color="primary" (click)='guardar()' [disabled]="registerForm.invalid">Guardar</button> -->
  <button mat-button mat-dialog-close="false">Aceptar</button>
</mat-dialog-actions>
